// Attribute mapping to sections for CREDC Employment Land Items
export const attributeMapping = {
  General: ['*']
}